import formatDate from 'date-fns/format';
import formatDateRelative from 'date-fns/distance_in_words_to_now';
import numeral from 'numeral';
import pluralize from 'pluralize';
import startCase from 'lodash/startCase';

import cdn from './cdn';

export { cdn, formatDate, formatDateRelative, startCase };

export function formatNumber(number, format) {
  return numeral(number).format(format);
}

export function plural(value, text, withValue = true) {
  return pluralize(text, value, withValue === true);
}



// WEBPACK FOOTER //
// ./src/filters/index.js